import React, { useState } from 'react';
import TextFieldInline from '../../../../../../component-controller-mod/component-serv/input-fs-cp/text-field-op/ts/textFieldInline';
import TextAreaInline from '../../../../../../component-controller-mod/component-serv/input-fs-cp/textarea-field-op/ts/textAreaInline';

export const DraftTextField: React.FC<{
  initialValue?: string;
  placeholder?:  string;
  onChange:      (v: string) => void;
}> = ({ initialValue = '', placeholder, onChange }) => {
  const [draft, setDraft] = useState(initialValue);
  return (
    <TextFieldInline
      value={draft}
      placeholder={placeholder}
      onChange={(v: string) => { setDraft(v); onChange(v); }}
    />
  );
};

export const DraftTextArea: React.FC<{
  initialValue?: string;
  placeholder?:  string;
  rows?:         number;
  onChange:      (v: string) => void;
}> = ({ initialValue = '', placeholder, rows, onChange }) => {
  const [draft, setDraft] = useState(initialValue);
  return (
    <TextAreaInline
      value={draft}
      placeholder={placeholder}
      rows={rows}
      onChange={(v: string) => { setDraft(v); onChange(v); }}
    />
  );
};

export const LabelRow: React.FC<{
  label:     string;
  required?: boolean;
}> = ({ label, required }) => (
  <div className="scl--cms-content-edit-contact-label-row">
    <span className="scl--cms-content-edit-contact-label">
      {label}{required && <span className="scl--cms-content-edit-contact-required"> *</span>}
    </span>
  </div>
);

export const SplitRow: React.FC<{
  currentText: string;
  multiline?:  boolean;
  children:    React.ReactNode;
}> = ({ currentText, multiline, children }) => (
  <div className={`scl--cms-content-edit-contact-split-row${multiline ? ' scl--cms-content-edit-contact-split-row--multiline' : ''}`}>
    <div className="scl--cms-content-edit-contact-split-accent" />
    <div className="scl--cms-content-edit-contact-split-body">
      <span className="scl--cms-content-edit-contact-split-current">{currentText}</span>
      <div className={`scl--cms-content-edit-contact-split-slot${multiline ? ' scl--cms-content-edit-contact-split-slot--textarea' : ''}`}>
        {children}
      </div>
    </div>
  </div>
);